import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GroupSkipDirective} from '@dcp/accessibility';
import {IconButtonTooltipModule, LoadingIndicatorComponent} from '@dcp/configurator';
import {I18nModule, TranslatePipe} from '@spartacus/core';
import {InputModule, NgDesignSystemModule, TooltipModule, UploadModule} from 'ng-design-system';
import {DcpCheckoutModule} from '../checkout/checkout.module';
import {GenericCallErrorModule} from '../checkout/error-handling/generic-call-error/generic-call-error.module';
import {DelegoAddNewCcComponent} from '../payment/components/delego-cc-component/delego-add-new-cc.component';
import {StripeAddNewCcComponent} from '../payment/components/stripe-cc-component/stripe-add-new-cc.component';
import {PaymentModule} from '../payment/payment.module';
import {AddressesFormatterModule} from '../pipes/addresses-formatter/addresses-formatter.module';
import {AddressesFormatterPipe} from '../pipes/addresses-formatter/addresses-formatter.pipe';
import {NetNewModule} from '../product/configurator/error-handling/net-new/net-new.module';
import {ContentLoadingIndicatorModule} from '../shared/content-loading-indicator/content-loading-indicator.module';
import {DisposableMessageModule} from '../shared/disposable-message/disposable-message.module';
import {SummaryModule} from '../shared/summary/summary.module';
import {AddressDataComponent} from './address-data/address-data.component';
import {BuyerDetailsComponent} from './buyer-details/buyer-details.component';
import {AddressAddModalComponent} from './company-addresses/address-add-modal/address-add-modal.component';
import {CompanyAddressesComponent} from './company-addresses/company-addresses.component';
import {CompanyDetailsComponent} from './company-details/company-details.component';
import {DigitalNativeCheckoutComponent} from './digital-native-checkout.component';
import {BillingInformationComponent} from './payment-method-display/billing-information/billing-information.component';
import {PaymentMethodCreditcardComponent} from './payment-method-display/payment-method-creditcard/payment-method-creditcard.component';
import {PaymentMethodDisplayComponent} from './payment-method-display/payment-method-display.component';
import {PaymentMethodInvoiceComponent} from './payment-method-display/payment-method-invoice/payment-method-invoice.component';
import {TaxInformationComponent} from './tax-information/tax-information.component';
import {TechnicalContactsAddModalComponent} from './technical-contacts/technical-contacts-add-modal/technical-contacts-add-modal.component';
import {TechnicalContactsComponent} from './technical-contacts/technical-contacts.component';

@NgModule({
  declarations: [
    DigitalNativeCheckoutComponent,
    PaymentMethodInvoiceComponent,
    PaymentMethodCreditcardComponent,
    PaymentMethodDisplayComponent,
    TaxInformationComponent,
    BuyerDetailsComponent,
    CompanyDetailsComponent,
    AddressDataComponent,
    TechnicalContactsComponent,
    TechnicalContactsAddModalComponent,
    CompanyAddressesComponent,
    BillingInformationComponent,
    AddressAddModalComponent,
    DelegoAddNewCcComponent,
    StripeAddNewCcComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    InputModule,
    FormsModule,
    TooltipModule,
    NgDesignSystemModule,
    ReactiveFormsModule,
    UploadModule,
    SummaryModule,
    ContentLoadingIndicatorModule,
    AddressesFormatterModule,
    DcpCheckoutModule,
    GenericCallErrorModule,
    NetNewModule,
    DisposableMessageModule,
    PaymentModule,
    IconButtonTooltipModule,
    LoadingIndicatorComponent,
    GroupSkipDirective,
  ],
  providers: [TranslatePipe, AddressesFormatterPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [DigitalNativeCheckoutComponent],
})
export class DigitalNativeCheckoutModule {}
